<app-page-title title="Estudos de célula"></app-page-title>

<app-no-data *ngIf="!groupWords" title="Sem dados" subtitle=" Nenhuma estudo cadastrado"></app-no-data>

<cdk-virtual-scroll-viewport itemSize="50" class="viewport" *ngIf="groupWords">
  <div *ngFor="let groupWord of groupWords" class="card">
    <img src="../../../assets/icons/article-black.svg" width="38" />
    <div class="title" [routerLink]="['/palavra/vizualizar/' + groupWord.id]">
      {{ groupWord.theme }}
    </div>
    <div class="details">
      <h7>{{ groupWord.created_at | date: 'dd/MM/yyyy' }}</h7>
    </div>
  </div>
</cdk-virtual-scroll-viewport>

<div class="example-button-container">
  <button mat-fab aria-label="Example icon button with a delete icon" routerLink="/palavra/add">
    <img src="../../../assets/icons/add_white_24dp.svg" />
  </button>
</div>
